export default (actions, handler) => {
  const actionsToWatch = Array.isArray(actions) ? actions : [actions]
  return store => next => action => {
    next(action)
    // eslint-disable-next-line no-bitwise
    if (~actionsToWatch.indexOf(action.type)) handler(store, action)
  }
}
